var map = {
	"./carolina.png": 338,
	"./ernesto.png": 339,
	"./ivan.jpg": 340,
	"./karen.png": 341,
	"./laura.png": 342,
	"./luis.png": 343,
	"./manuel.png": 344,
	"./mariana.jpg": 345,
	"./sergio.png": 346,
	"./susana.png": 347
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos ^\.\/.*$
// module id = 337
// module chunks = 0